Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentTikTokMediaView extends Backbone.View
  template: JST["backbone/templates/monitoring/social_contents_v2/social_content_tiktok_media"]
  className: 'sc-media'

  initialize: (options = {}) ->
    @video = options.video
    @thumbnail = options.thumbnail
    @showVideoAsLink = options.showVideoAsLink

  render: ->
    @$el.html @template { @video, @thumbnail, @showVideoAsLink }
    this
